import { render, staticRenderFns } from "./PermissionMethodRow.vue?vue&type=template&id=2bb46c62&scoped=true"
import script from "./PermissionMethodRow.vue?vue&type=script&lang=js"
export * from "./PermissionMethodRow.vue?vue&type=script&lang=js"
import style0 from "./PermissionMethodRow.vue?vue&type=style&index=0&id=2bb46c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb46c62",
  null
  
)

export default component.exports